import { useEffect, useState } from 'react';
import { type UserInfo } from '@monorepo-hol/providers';

import type { PdfData } from '../../../types/documents';
import {
  type LangStateType,
  useLanguageContext,
} from '../../../provider/LanguageProvider';
import { useGetTranslationDocument2 } from '../../../modules/document';
import type { DataDocumentDetail } from '../services/document-detail/types';
import type { AccessRight } from '../../../types/metadata';
import { MainCatalog } from '../../../types/catalog';

export interface UseTranslationDataProps {
  guid: string;
  docId?: string;
  user: UserInfo;
  data: DataDocumentDetail;
  catalogAcl: AccessRight;
  catalogData: MainCatalog;
}

export interface IUseTranslationData {
  isDocumentReady: boolean;
  isDocumentError: boolean;
  pdfDoc: PdfData;
  LangState: LangStateType;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  lampiranTerjemahan?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  translationDocument?: any;
}

export function useTranslationData({
  guid,
  docId,
  data,
  user,
  catalogAcl,
  catalogData,
}: UseTranslationDataProps): IUseTranslationData {
  const [isDocumentReady, setIsDocumentReady] = useState(false);
  const [isDocumentError, setIsDocumentError] = useState(false);
  const [pdfDoc, setPdfDoc] = useState<PdfData>(null);
  const [lampiranTerjemahan, setLampiranTerjemahan] = useState();
  const { LangState } = useLanguageContext();

  const { translationStatus, translationData, appendicesEn } =
    useGetTranslationDocument2({
      guid: guid,
      jwt: user?.jwt || '',
      type: 'translation',
      docId: catalogData?.pdfDocumentGuid,
      data,
      authorized: catalogAcl?.translations === 'authorized',
      mainDocument: catalogData?.mainDocument,
    });

  useEffect(() => {
    if (translationStatus === 'success') {
      setIsDocumentReady(true);
      setPdfDoc(translationData);
      setLampiranTerjemahan(appendicesEn);
    } else if (translationStatus === 'error') {
      setIsDocumentReady(true);
      setPdfDoc(translationData);
      setIsDocumentError(true);
    } else if (translationStatus === 'loading') {
      setIsDocumentReady(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [translationStatus]);

  return {
    isDocumentReady,
    isDocumentError,
    pdfDoc,
    LangState,
    lampiranTerjemahan,
  };
}
